import React from 'react';
import { StyledSpinner } from './styles';

const Spinner = () => {
  return <StyledSpinner></StyledSpinner>;
};
export default Spinner;
